import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

type MaxxSettingsTab = 'slack' | 'monitoring' | 'brandKit' | 'capabilities';

@Component({
  selector: 'pdq-maxx-settings-page',
  templateUrl: './maxx-settings-page.component.html',
  styleUrls: ['./maxx-settings-page.component.scss'],
  standalone: false,
})
export class MaxxSettingsPageComponent implements OnInit {
  activeTab: MaxxSettingsTab = 'slack';
  readonly tabs: { value: MaxxSettingsTab; label: string }[] = [
    { value: 'slack', label: 'Slack' },
    { value: 'monitoring', label: 'Monitoring' },
    { value: 'brandKit', label: 'Brand kit' },
    { value: 'capabilities', label: 'Capabilities' },
  ];

  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const tab = this.route.snapshot.queryParamMap.get('tab');
    this.activeTab = this.tabs.find((item) => item.value === tab)?.value ?? this.activeTab;
  }

  selectTab(value: string): void {
    this.activeTab = value as MaxxSettingsTab;
  }
}
